import numberWithCommas from './numberWithCommas'

/**
 * Format number for display value
 * @param  {Number} n     a number object
 * @param  {String} unit  number type
 * @return {Number}       formatted number
 */
export default function formatNumber (n, unit) {
  if (!n) return null

  n = Number(n)

  let formatted = n

  if (unit) {
    if (unit === '$') {
      formatted = `${unit}${numberWithCommas(n.toFixed(2))}`
    }
    else {
      formatted = `${numberWithCommas(n)}/${unit}`
    }
  }

  return formatted
}



// WEBPACK FOOTER //
// ./modules/utils/formatNumber.js